import { render, staticRenderFns } from "./PageImageAvatar.vue?vue&type=template&id=2a91312a&"
import script from "./PageImageAvatar.vue?vue&type=script&lang=js&"
export * from "./PageImageAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports